import { chains } from '@constants';
import { ChainConfig } from '@types';

export const getChainConfig = (): ChainConfig[] => chains.map((chain) => ({
  title: chain.chainName,
  id: chain.chainId,
  icon: chain.icon,
  alias: chain.alias,
})).filter(Boolean);
